import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-smartfeed-status',
  templateUrl: './smartfeed-status.component.html',
  styleUrls: ['./smartfeed-status.component.scss'],
})
export class SmartfeedStatusComponent implements OnInit {
  @Input()
  connectionStatus: number;

  @Input()
  lastOnline: Date;

  @Input()
  friendlyName: string;

  @Input()
  thingName: string;

  @Input()
  registrationDate: Date;

  @Input()
  firmwareVersion: string;

  constructor() {}

  ngOnInit() {}

  ConnectionStatus() {
    switch (this.connectionStatus) {
      case 0:
        return 'Offline';
      case 1:
        return 'Connecting';
      case 2:
        return 'Online';
      case 3:
        return 'Firmware Upgrading';
      case 4:
        return 'Firmware Upgrade Failed';
    }
  }
}
